<template>
<PageHeader :title="resolvedPlaceTitle" />
<CitySubnav :cities="['amsterdam','hamburg','berlin','paris','Utrecht','Norway', 'Costa Rica','San Diego','Panama','Seattle','Seoul']" />
    <div class="portfolio">
    <h1 class="page-title">{{ resolvedPlaceTitle }}</h1>
    
  <PortfolioJustified
    :items="items"
    :target-row-height="300"
    :gutter="12"
    last-row="left"
    :show-captions="true"
    />

  </div>
</template>

<script setup>

import { ref, computed, onMounted } from 'vue'

import { useRoute } from 'vue-router'
import PageHeader from './PageHeader.vue'
import PortfolioJustified from '@/components/PortfolioJustified.vue'
import CitySubnav from '@/components/CitySubnav.vue'

const props = defineProps({
  place: { type: String, required: false } // can be passed from router or parent
})

// read from prop *or* route param (if you configured props: true on the route)
const route = useRoute()
const placeKey = computed(() =>
  (props.place ?? route.params.place ?? '')
    .toString()
    .trim()
    .toLowerCase()
)

// Your catalog of photos by place (expand as you go)
const catalog = {
  amsterdam: [
    { src: '/portfolio/18.jpg', caption: 'Amsterdam', w: 1365, h: 2048 },
    { src: '/portfolio/19.jpg', caption: 'Amsterdam', w: 2048, h: 1365 },
      { src: '/portfolio/23.jpg', caption: 'Amsterdam', w: 1365, h: 2048 },
    { src: "/portfolio/25.jpg", caption: "Amsterdam",w: 1365, h: 2048  },
    { src: "/portfolio/26.jpg", caption: "Amsterdam", w: 2048, h:1365 },

    { src: "/portfolio/28.jpg", caption: "Amsterdam",  w: 1365, h: 2048 },
    { src: "/portfolio/29.jpg", caption: "Amsterdam", w: 2048, h:1365},
    { src: "/portfolio/30.jpg", caption: "Amsterdam",  w: 1365, h: 2048 },
    { src: "/portfolio/31.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048},
    { src: "/portfolio/32.jpg", caption: "Amsterdam",  w: 2048, h:1365 },
    { src: "/portfolio/33.jpg", caption: "Amsterdam", w: 1365, h: 2048 },
      { src: "/portfolio/34.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048},
     { src: "/portfolio/121.jpg", caption: "Amsterdam", w: 2048, h:1365 },

      { src: "/portfolio/123.jpg", caption: "Amsterdam" , w: 1365, h: 2048 },

      { src: "/portfolio/125.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048 },
      { src: "/portfolio/127.jpg", caption: "Amsterdam"  ,  w: 1365, h: 2048 },
      { src: "/portfolio/128.jpg", caption: "Amsterdam"  ,  w: 1365, h: 2048 },
      { src: "/portfolio/129.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/130.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048 },
     { src: "/portfolio/143.jpg", caption: "Amsterdam",   w: 2048, h:1365 },

      { src: "/portfolio/144.jpg", caption: "Amsterdam",   w: 2048, h:1365 },
      { src: "/portfolio/145.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/146.jpg", caption: "Amsterdam",  w: 1365, h: 2048 },
      { src: "/portfolio/147.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048 },
      { src: "/portfolio/151.jpg", caption: "Amsterdam",   w: 2048, h:1365 },
      
      { src: "/portfolio/152.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/153.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/154.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },
      { src: "/portfolio/155.jpg", caption: "Amsterdam" ,  w: 1365, h: 2048 },
      { src: "/portfolio/156.jpg", caption: "Amsterdam" ,   w: 2048, h:1365 },

      { src: "/portfolio/67.jpg", caption: "Amsterdam" , w: 2048, h: 1365},
      { src: "/portfolio/465.jpg", caption: "Amsterdam" , w: 2048, h: 1365},
      { src: "/portfolio/466.jpg", caption: "Amsterdam" ,   w: 1638, h:2048 },
      { src: "/portfolio/467.jpg", caption: "Amsterdam" ,   w: 1365, h:2048 },
      { src: "/portfolio/468.jpg", caption: "Amsterdam" ,   w: 2048, h:1638 },
      { src: "/portfolio/469.jpg", caption: "Amsterdam" ,  w: 2048, h: 1365 },
      { src: "/portfolio/470.jpg", caption: "Amsterdam" ,   w: 2048, h:1638 },
      { src: "/portfolio/471.jpg", caption: "Amsterdam",   w: 1365, h:2048 },
      { src: "/portfolio/474.jpg", caption: "Amsterdam" ,  w: 2048, h: 1365 },
      { src: "/portfolio/475.jpg", caption: "Amsterdam" ,   w: 2048, h:1536 },
      { src: "/portfolio/476.jpg", caption: "Amsterdam",   w: 2048, h:1365 },


      

  ],
    cologne: [
	// add Hamburg
	{ src: "/portfolio/71.jpg", caption: "Köln",w: 2048, h: 1365 },
	],
  hamburg: [
      // add Hamburg images here
      { src: "/portfolio/54.jpg", caption: "Hamburg",w: 1365, h: 2048 },
{ src: "/portfolio/55.jpg", caption: "Hamburg" , w: 1365, h: 2048 },
    { src: "/portfolio/56.jpg", caption: "Hamburg", w: 1365, h: 2048 },
    { src: "/portfolio/57.jpg", caption: "Hamburg" , w: 1365, h: 2048 },
    { src: "/portfolio/58.jpg", caption: "Hamburg", w: 1365, h: 2048 },
    { src: "/portfolio/59.jpg", caption: "Hamburg" , w: 1365, h: 2048 },
    { src: "/portfolio/60.jpg", caption: "Hamburg", w: 1365, h: 2048 },
    { src: "/portfolio/61.jpg", caption: "Hamburg" , w: 1365, h: 2048 },
    { src: "/portfolio/62.jpg", caption: "Hamburg", w: 2048, h:1365 },
    { src: "/portfolio/63.jpg", caption: "Hamburg" , w: 2048, h:1365 },
    { src: "/portfolio/64.jpg", caption: "Hamburg", w: 2048, h:1365 },

      { src: "/portfolio/66.jpg", caption: "Hamburg", w: 1365, h: 2048 },
          { src: "/portfolio/204.jpg", caption: "Hamburg", w: 1365, h: 2048 },
  ],
sandiego: [
    // add Hamburg images here
    { src: "/portfolio/207.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/206.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/208.jpg", caption: "San Diego", w: 1365, h: 2048 },        
    { src: "/portfolio/205.jpg", caption: "San Diego", w: 1365, h: 2048 },
    

    { src: "/portfolio/209.jpg", caption: "San Diego", w:2048 , h: 1365 },
    { src: "/portfolio/210.jpg", caption: "San Diego", w: 1365, h: 2048 },        
    { src: "/portfolio/211.jpg", caption: "San Diego", w: 1365, h: 2048 },

    { src: "/portfolio/214.jpg", caption: "San Diego", w:1365 , h: 2048 },
    { src: "/portfolio/215.jpg", caption: "San Diego", w: 1365, h: 2048 },        
    { src: "/portfolio/216.jpg", caption: "San Diego", w: 1365, h: 2048 },

        { src: "/portfolio/217.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/218.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/219.jpg", caption: "San Diego", w: 1365, h: 2048 },

    { src: "/portfolio/220.jpg", caption: "San Diego", w:2048 , h: 1365 },
//    { src: "/portfolio/221.jpg", caption: "San Diego", w:2048 , h: 1365 },

       { src: "/portfolio/226.jpg", caption: "San Diego", w:2048 , h: 1365 },
    { src: "/portfolio/227.jpg", caption: "San Diego", w:2048 , h: 1365 },
        { src: "/portfolio/228.jpg", caption: "San Diego", w:2048 , h: 1365 },
 
    { src: "/portfolio/222.jpg", caption: "San Diego", w: 1365, h: 2048 },

    { src: "/portfolio/223.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/224.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/225.jpg", caption: "San Diego", w: 1365, h: 2048 },
    
    { src: "/portfolio/229.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/230.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/231.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/232.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/233.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/234.jpg", caption: "San Diego", w: 2048, h: 1365 },

    { src: "/portfolio/235.jpg", caption: "San Diego", w: 2048, h: 1365 },

        { src: "/portfolio/236.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/237.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/238.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/239.jpg", caption: "San Diego", w: 1365, h: 2048 },
        { src: "/portfolio/240.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/241.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/242.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/243.jpg", caption: "San Diego", w: 1365, h: 2048 },
        { src: "/portfolio/244.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/245.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/246.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/247.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/248.jpg", caption: "San Diego", w: 2048, h: 1365 },

{ src: "/portfolio/249.jpg", caption: "San Diego", w: 1365, h: 2048 },
 { src: "/portfolio/250.jpg", caption: "San Diego", w: 1365, h: 2048 },

        { src: "/portfolio/254.jpg", caption: "San Diego", w: 1365, h: 2048 },    
 { src: "/portfolio/255.jpg", caption: "San Diego", w: 1365, h: 2048 },

        { src: "/portfolio/256.jpg", caption: "San Diego", w: 1365, h: 2048 },    
 { src: "/portfolio/257.jpg", caption: "San Diego", w: 1365, h: 2048 },

    { src: "/portfolio/258.jpg", caption: "San Diego", w: 1365, h: 2048 },
    { src: "/portfolio/259.jpg", caption: "San Diego", w: 1365, h: 2048 },

 { src: "/portfolio/260.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/261.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/262.jpg", caption: "San Diego", w: 2048, h: 1365 },    
 { src: "/portfolio/263.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/264.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/265.jpg", caption: "San Diego", w: 2048, h: 1365 },    
 { src: "/portfolio/266.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/267.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/268.jpg", caption: "San Diego", w: 2048, h: 1365 },
        { src: "/portfolio/269.jpg", caption: "San Diego", w: 1365, h: 2048 },

    { src: "/portfolio/270.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/271.jpg", caption: "San Diego", w: 2048, h: 1365 },
        { src: "/portfolio/272.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/273.jpg", caption: "San Diego", w: 2048, h: 1365 },
    { src: "/portfolio/274.jpg", caption: "San Diego", w: 2048, h: 1365 },
        { src: "/portfolio/275.jpg", caption: "San Diego", w: 2048, h: 1365 },
        { src: "/portfolio/276.jpg", caption: "San Diego", w: 2048, h: 1365 },
    
    
],
   berlin: [
	    { src: "/portfolio/43.jpg", caption: "Berlin" },
    { src: "/portfolio/45.jpg", caption: "Berlin" },
    { src: "/portfolio/46.jpg", caption: "Berlin" },
    { src: "/portfolio/47.jpg", caption: "Berlin" },
    { src: "/portfolio/48.jpg", caption: "Berlin" },

    { src: "/portfolio/50.jpg", caption: "Berlin" },
    { src: "/portfolio/51.jpg", caption: "Berlin" },
    { src: "/portfolio/52.jpg", caption: "Berlin" },
       { src: "/portfolio/53.jpg", caption: "Berlin" }],
    paris: [
	  { src: "/portfolio/74.jpg", caption: "Paris" },
      { src: "/portfolio/75.jpg", caption: "Paris" },

      { src: "/portfolio/78.jpg", caption: "Paris" },
      { src: "/portfolio/79.jpg", caption: "Paris" },
      { src: "/portfolio/80.jpg", caption: "Paris" },

      { src: "/portfolio/82.jpg", caption: "Paris" },
      { src: "/portfolio/83.jpg", caption: "Paris" },
      { src: "/portfolio/84.jpg", caption: "Paris" },
      { src: "/portfolio/85.jpg", caption: "Paris" },
      { src: "/portfolio/86.jpg", caption: "Paris" },
      { src: "/portfolio/87.jpg", caption: "Paris" },
      { src: "/portfolio/88.jpg", caption: "Paris" },
      { src: "/portfolio/89.jpg", caption: "Paris" },
      { src: "/portfolio/91.jpg", caption: "Paris" },
      { src: "/portfolio/92.jpg", caption: "Paris" },
      { src: "/portfolio/93.jpg", caption: "Paris" },
      { src: "/portfolio/94.jpg", caption: "Paris" },
      { src: "/portfolio/95.jpg", caption: "Paris" },

      { src: "/portfolio/97.jpg", caption: "Paris" },
      { src: "/portfolio/98.jpg", caption: "Paris" },
      { src: "/portfolio/99.jpg", caption: "Paris" },
      { src: "/portfolio/100.jpg", caption: "Paris" },
      { src: "/portfolio/101.jpg", caption: "Paris" },
      { src: "/portfolio/102.jpg", caption: "Paris" },
      { src: "/portfolio/103.jpg", caption: "Paris" },
      { src: "/portfolio/104.jpg", caption: "Paris" },
      { src: "/portfolio/105.jpg", caption: "Paris" },
      { src: "/portfolio/106.jpg", caption: "Paris" },
      { src: "/portfolio/107.jpg", caption: "Paris" },
      { src: "/portfolio/108.jpg", caption: "Paris" },

      { src: "/portfolio/110.jpg", caption: "Paris" },
      { src: "/portfolio/111.jpg", caption: "Paris" },
      { src: "/portfolio/112.jpg", caption: "Paris" },
      { src: "/portfolio/113.jpg", caption: "Paris" },
      { src: "/portfolio/115.jpg", caption: "Paris" },
      { src: "/portfolio/116.jpg", caption: "Paris" },
	{ src: "/portfolio/117.jpg", caption: "Paris" }
    ],
    utrecht: [
	      { src: "/portfolio/118.jpg", caption: "Utrecht" ,w: 1365, h: 2048 },
      { src: "/portfolio/119.jpg", caption: "Utrecht" ,   w: 2048, h:1365 },
      { src: "/portfolio/120.jpg", caption: "Utrecht",w: 1365, h: 2048 },
	{ src: "/portfolio/122.jpg", caption: "Utrecht" ,   w: 2048, h:1365 },
],
	norway: [
	       { src: "/portfolio/131.jpg", caption: "Norway" },      
      { src: "/portfolio/132.jpg", caption: "Norway" },
      { src: "/portfolio/134.jpg", caption: "Norway" },
      { src: "/portfolio/135.jpg", caption: "Norway" },
      { src: "/portfolio/136.jpg", caption: "Norway" },
      { src: "/portfolio/138.jpg", caption: "Norway" },      
      { src: "/portfolio/139.jpg", caption: "Norway" },
      { src: "/portfolio/140.jpg", caption: "Norway" },      
	    { src: "/portfolio/141.jpg", caption: "Norway" },
	],
    costarica: [
	     { src: "/portfolio/159.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/160.jpg", caption: "Costa Rica" , w: 2048, h:1365 },
      { src: "/portfolio/161.jpg", caption: "Costa Rica",   w: 2048, h:1365 },
      { src: "/portfolio/162.jpg", caption: "Costa Rica",   w: 2048, h:1365 },
      { src: "/portfolio/163.jpg", caption: "Costa Rica" ,   w: 2048, h:1365 },
      { src: "/portfolio/164.jpg", caption: "Costa Rica" ,w: 1365, h: 2048 }, 
      { src: "/portfolio/165.jpg", caption: "Costa Rica",w: 1365, h: 2048 },
      { src: "/portfolio/166.jpg", caption: "Costa Rica" ,w: 1365, h: 2048 },

      { src: "/portfolio/167.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/168.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/169.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/170.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/172.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      
      { src: "/portfolio/173.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/174.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/176.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/177.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/178.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/179.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/180.jpg", caption: "Costa Rica",  w: 2048, h:1365 },


      { src: "/portfolio/182.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/184.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/185.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/186.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },

      { src: "/portfolio/188.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/190.jpg", caption: "Costa Rica",  w: 2048, h:1365 },


      { src: "/portfolio/191.jpg", caption: "Costa Rica" ,w: 1365, h: 2048 }, 
            { src: "/portfolio/192.jpg", caption: "Costa Rica",w: 1365, h: 2048 }, 
      { src: "/portfolio/193.jpg", caption: "Costa Rica",w: 1365, h: 2048 }, 
      { src: "/portfolio/194.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/195.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/196.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/197.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/198.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },

            { src: "/portfolio/199.jpg", caption: "Costa Rica" ,  w: 2048, h:1365 },
      { src: "/portfolio/200.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
      { src: "/portfolio/201.jpg", caption: "Costa Rica",  w: 2048, h:1365 },

      { src: "/portfolio/202.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
	{ src: "/portfolio/203.jpg", caption: "Costa Rica",  w: 2048, h:1365 },
    ],
    panama: [
	{ src: "/portfolio/278.jpg", caption: "Panama",  w: 2048, h:1365 },
	{ src: "/portfolio/279.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/280.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/281.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/282.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/283.jpg", caption: "Panama",  w: 2048, h:1365 },
	{ src: "/portfolio/284.jpg", caption: "Panama",  w: 2048, h:1365 },
	{ src: "/portfolio/285.jpg", caption: "Panama" ,w: 1365, h: 2048 },

	{ src: "/portfolio/286.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/287.jpg", caption: "Panama",  w: 1365, h:2048 }, //h
	{ src: "/portfolio/288.jpg", caption: "Panama",  w: 1365, h:2048 },
	{ src: "/portfolio/289.jpg", caption: "Panama" ,w: 1365, h: 2048 },	


	{ src: "/portfolio/290.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/291.jpg", caption: "Panama",  w: 1365, h:2048 },
	{ src: "/portfolio/292.jpg", caption: "Panama",  w: 1365, h:2048 },
	{ src: "/portfolio/293.jpg", caption: "Panama" ,w: 1365, h: 2048 },	

		{ src: "/portfolio/294.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/295.jpg", caption: "Panama",  w: 2048, h:1365 },
	{ src: "/portfolio/296.jpg", caption: "Panama",  w: 2048, h:1365 },
	{ src: "/portfolio/297.jpg", caption: "Panama" ,w: 2048, h: 1365 },
	{ src: "/portfolio/298.jpg", caption: "Panama" ,w: 2048, h: 1365 },

	{ src: "/portfolio/299.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/300.jpg", caption: "Panama" ,w: 1365, h: 2048 },

	{ src: "/portfolio/301.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/302.jpg", caption: "Panama" ,w: 1365, h: 2048 },				
	{ src: "/portfolio/303.jpg", caption: "Panama" ,w: 1365, h: 2048 },

	{ src: "/portfolio/304.jpg", caption: "Panama" ,w: 1365, h: 2048 },
	{ src: "/portfolio/305.jpg", caption: "Panama" ,w: 1365, h: 2048 },				

    ],
    frankfurt: [
		{ src: "/portfolio/463.jpg", caption: "Frankfurt" ,w: 1365, h: 2048 },
	],
    seattle: [
	{ src: "/portfolio/306.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/307.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/308.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/310.jpg", caption: "Seattle" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/311.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/312.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/313.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/314.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/315.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/316.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/317.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/318.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/319.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/320.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/321.jpg", caption: "Seattle" ,w: 1365, h: 2048 },

	{ src: "/portfolio/323.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/324.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/325.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/326.jpg", caption: "Seattle" ,w: 2048, h: 1365 },

	{ src: "/portfolio/328.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/329.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/330.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/331.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/332.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/333.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/334.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/335.jpg", caption: "Seattle" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/336.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/337.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/338.jpg", caption: "Seattle" ,w: 2048, h: 1365 },
	{ src: "/portfolio/339.jpg", caption: "Seattle" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/340.jpg", caption: "Seattle" ,w: 1365, h: 2048 },
	{ src: "/portfolio/341.jpg", caption: "Seattle" ,w: 2048, h: 1365 },

    ],
    seoul: [
	{ src: "/portfolio/342.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/343.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/344.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/345.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/346.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/347.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/348.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/349.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/350.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/351.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/352.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/354.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/356.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/357.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/358.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/359.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/360.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/361.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/371.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/372.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/373.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/374.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/375.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/376.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/377.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/378.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/379.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	
	{ src: "/portfolio/380.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/381.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/382.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/383.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					

	{ src: "/portfolio/385.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/386.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/387.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/388.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/389.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/390.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/391.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/392.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					

	{ src: "/portfolio/394.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/395.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/396.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/397.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/398.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/399.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/400.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/401.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/402.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/403.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	
	{ src: "/portfolio/404.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/405.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/406.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/407.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/408.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/409.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/410.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/411.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/412.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/413.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/414.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/415.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/416.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/417.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/418.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/419.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/420.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/421.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/422.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/423.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/424.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/425.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/426.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/427.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/428.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/429.jpg", caption: "Seoul" ,w: 1365, h: 2048 },


	{ src: "/portfolio/431.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/432.jpg", caption: "Seoul" ,w: 2048, h: 1365 },					
	{ src: "/portfolio/433.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/434.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/435.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/436.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/437.jpg", caption: "Seoul" ,w: 2048, h: 1365 },



	{ src: "/portfolio/442.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/443.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/444.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/445.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/446.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/447.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/448.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/449.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/450.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/451.jpg", caption: "Seoul" ,w: 1365, h: 2048 },					
	{ src: "/portfolio/453.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/454.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/455.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/456.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/457.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/458.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/459.jpg", caption: "Seoul" ,w: 2048, h: 1365 },

	{ src: "/portfolio/460.jpg", caption: "Seoul" ,w: 1365, h: 2048 },
	{ src: "/portfolio/461.jpg", caption: "Seoul" ,w: 2048, h: 1365 },
	{ src: "/portfolio/462.jpg", caption: "Seoul" ,w: 2048, h: 1365 },	
	
	]

}

// Fallback: if place not found, show everything
const allItems = Object.values(catalog).flat()
const items = computed(() => catalog[placeKey.value] ?? allItems)

const resolvedPlaceTitle = computed(() =>
  placeKey.value
    ? placeKey.value[0].toUpperCase() + placeKey.value.slice(1)
    : 'Portfolio'
)

onMounted(() => {
    console.log('mounted') // same timing as Options API's mounted()
    console.log(props)
})
</script>


<style scoped>
.portfolio {
  padding: 16px;
}
.page-title {
  margin: 0 0 16px;
  font-size: clamp(28px, 3vw, 44px);
  line-height: 1.1;
}

.portfolio h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;    /* lighter still */
  font-size: 1.5rem;   /* 24px */
  line-height: 1.4;
  margin: 1rem 0;
  text-align: center;    /* often nice for titles */
  color: orange;
}
</style>
